export const CANNED_REASON_AI_ERROR = "AI Error";
export const CANNED_REASON_WRONG_IMAGE = "Wrong Image";
export const CANNED_REASONS = [CANNED_REASON_AI_ERROR, CANNED_REASON_WRONG_IMAGE];

/** Case-insensitive match against the canned reasons. */
export const isCannedReason = (text: string): boolean =>
    CANNED_REASONS.some((c) => c.toLowerCase() === text.trim().toLowerCase());

/** Reasons to offer for reuse (canned reasons filtered out), preserving order. */
export const pickReuseReasons = (reasons: string[]): string[] =>
    reasons.filter((reason) => !isCannedReason(reason));
